import journal from '../img/journal.png'
import React from 'react';
import FrontRecapitulatif from './recapitulatif';
import FrontDocuments from './documents';
import waiter from '../img/wait.svg'
import FrontFooter from './footer'
import download from '../img/file-download-line.png'
import FrontProgress from './progress';

export default class FrontPaidSubscribed extends React.Component {
    
    constructor(props) {
        super(props);
        this.timer = false
        this.dateFormatter = new Intl.DateTimeFormat('fr',{ dateStyle: 'short', timeStyle: 'short' })
    }


    periodic() {
        if ( this.props.devis.getting_documents == 1 ) {
            this.props.checkStatus({getting_documents:1})
        }
    }

    componentDidMount() {
        this.timer = setInterval(
            this.periodic.bind(this),
            4000
        )
    }

    componentWillUnmount() {
        if ( this.timer ) {
            clearInterval( this.timer )
            this.timer = false
        }
    }

    renderExternal(container) {
        return <><h1 className="top_title">
        Merci pour votre souscription
        </h1>
        <p className="text">
            Vous avez choisi de souscrire à l'offre de notre partenaire.
        </p>
        </>
    }

    renderOk(container) {
        const hamonApplies = container.devis.hamonApplies()
        const since_payment = this.dateFormatter.format(1000*(container.devis.t_payment+3600))
        const since = ( since_payment.startsWith(container.devis.params.date_effet) )
            ? <><b>{since_payment}</b> (la garantie provisoire de 30 jours est effective 1h après le paiement de l'acompte par carte bancaire)</>
            : <><b>{container.devis.params.date_effet}</b> (la garantie provisoire dure 30 jours à partir de cette date)</>
        return <><h1 className="top_title">
            Merci pour votre souscription
            </h1>
            <h4>
            Conservez votre numéro de contrat &nbsp; <span className="information_source">{container.devis.params.subscribeId}</span>
            </h4>

            <p className="text">Nous vous confirmons que votre souscription par carte bancaire sur le site www.assurbonplan.fr a été prise en compte.</p>
            <p className="text">Vous trouverez le contrat {hamonApplies?'':'et la carte verte provisoire'} ci-dessous.</p>

            {( container.devis.t_payment && !hamonApplies )
            ?<p className="text">Vous êtes assuré à partir du {since}.</p>
            :''}
            <p className="text">
            Nous sommes très heureux de vous compter parmi nos clients.
            </p>
            <p className="text">
            Notre service gestion est à votre disposition au <a href="tel:09 74 77 28 60">09 74 77 28 60</a> du lundi au vendredi de 9h00 à 13h00.
            </p>
            <p className="text">
            Vous pouvez également nous joindre ou envoyer vos justificatifs par email à l'adresse <a href="gestion@assurbonplan.fr">gestion@assurbonplan.fr</a>
            </p>
            <p className="text">
            Afin de nous permettre de valider votre contrat et recevoir vos documents officiels (carte verte), nous vous remercions par avance de bien vouloir nous faire parvenir <b>dans les 15 jours les documents suivants</b>:
            </p>
            <ul>
            {hamonApplies?<li>le mandat de résiliation rempli afin que nous puissions demander la résiliation auprès de votre précédent assureur</li>:<></>}
            <li>un exemplaire de la demande d'assurance et de la fiche d'information dûment signés</li>
            <li>l'original du (des) relevé(s) d'informations daté(s) de moins de trois mois</li>
            <li>en cas de prélèvement mensuel, le Mandat de Prélèvement SEPA signé et accompagné d'un R.I.B.</li>
            <li>la copie recto/verso du permis de conduire en cours de validité</li>
            <li>la copie de la carte grise du véhicule assuré ou du certificat provisoire d'immatriculation au nom de l'assuré</li>
            </ul>
            <FrontDocuments api={this.props.api} container={container}/>
            {hamonApplies?
            <a className="document_download" href="https://xenabot.assurbonplan.fr/mandat_resiliation_xena.pdf"><img src={download}/> Mandat de résiliation (loi Hamon)</a>
            :''}
        </>
    }

    renderWaiting(container) {
        return <><br/><p className="main_line">
                Encore quelques secondes, nous récupérons vos documents
            </p>
            <p>
                <img src={waiter} className="little_waiter"/>
            </p>
        </>
    }

    renderError(container) {
        const params = container.devis.params
        return <><br/><p className="main_line">
                Désolé, la récupération de vos documents a échoué&nbsp;:
            </p>
            <p className="error">
                {params.error}
            </p>
            <p className="main_line">
                Un conseiller va prendre contact au plus vite avec vous pour régulariser votre dossier. 
                N'hésitez pas à nous appeler dès maintenant.
            </p>
        </>
    }

    renderContent(container) {
        switch ( container.devis.getting_documents ) {
            case 3: return this.renderExternal(container)
            case 2: return this.renderOk(container)
            case 1: return this.renderWaiting(container)
            default:
                return this.renderError(container)
        }
    }

    render() {
        const container = {
            devis:this.props.devis,
            changeParams:this.props.changeParams,
            setPage: this.props.setPage
        }
        const content = this.renderContent(container)
        return <>
        <FrontProgress comparateursCompleted={true} setPage={this.props.setPage} page={this.props.page} topRef={this.props.topRef}/>
        <div className="container">

            <div className="contentbox front_form">
                <div className="contentvbox">

                {content}
                </div>
            </div>
            <div className="contentbox_middle"/>

            <div className="contentbox contentbox_right">
                <FrontRecapitulatif api={this.props.api} devis={this.props.devis} container={container}/>

                <h1 className="subscribe">Contactez nous par téléphone</h1>
                <a href="tel:0974772861" className="tel">09 74 77 28 61</a>
            </div>

            </div>
            <FrontFooter/>

        </>
    }
}